<div class="page-wrapper">
  <section class="about-breadcrumb">
  <div class="about-breadcrumb-overlay">
    <div class="container-fluid">
      <div class="banner-detail-copy">
        <p class="banner-eyebrow">MUF-K.Integrated</p>
        <h1>Connect insurers and service providers across the full claims lifecycle.</h1>
        <p class="banner-lead">MUF-K.Integrated is a web-based incident and claims-management platform designed to coordinate communication, work assignment and operational progress from initial notification through final service-provider resolution.</p>
        
      </div>
    </div>
  </div>
</section>

  <main class="v6-page">

    <section class="v6-promise-section mufk-opportunity-section">
      <div class="v6-container v6-promise-grid">
        <div class="mufk-opportunity-copy">
          <p class="v6-kicker v6-light-kicker">The opportunity</p>
          <h2>One shared view of claim progress.</h2>
          <a class="mufk-brand-link" href="https://mufk85.co.za/" target="_blank" rel="noopener noreferrer" aria-label="Explore the MUF-K.Integrated platform">
            <img src="/assets/img/Mutk-Integrated logo.png" alt="MUF-K.Integrated" class="mufk-product-logo" />
            <span>Explore the platform <span aria-hidden="true">↗</span></span>
          </a>
        </div>
        <ul><li><span>01</span>Clear ownership across every stage</li><li><span>02</span>Consistent communication and case information</li><li><span>03</span>Operational visibility for insurer and provider teams</li></ul>
      </div>
    </section>

    <section class="v6-capability-section" id="capabilities">
      <div class="v6-container">
        <div class="v6-capability-intro"><p class="v6-kicker">Capabilities</p><h2>Coordinate the lifecycle from notification to resolution.</h2><p>Replace fragmented emails, hand-offs and documents with a shared operational workflow that shows what has happened, what comes next and who is responsible.</p></div>
        <div class="v6-capability-grid"><article><span>01</span><h3>Capture</h3><p>Record the incident or claim and establish a consistent case record.</p></article><article><span>02</span><h3>Assign</h3><p>Route work to an approved provider based on operational rules and network structure.</p></article><article><span>03</span><h3>Track</h3><p>Maintain visibility of progress, actions, updates and exceptions.</p></article><article><span>04</span><h3>Communicate</h3><p>Keep operational communication and case information connected.</p></article><article><span>05</span><h3>Approve</h3><p>Capture documents, evidence and decisions needed to progress the claim.</p></article><article><span>06</span><h3>Report</h3><p>Monitor volumes, turnaround and provider performance where enabled.</p></article></div>
      </div>
    </section>

    <section class="v6-delivery-section">
      <div class="v6-container">
        <div class="v6-delivery-heading"><p class="v6-kicker">How we work</p><h2>A connected claims workflow.</h2></div>
        <div class="v6-delivery-grid"><article><span>1</span><h3>Notify</h3><p>Create the claim and capture essential information.</p></article><article><span>2</span><h3>Coordinate</h3><p>Assign providers and manage actions in one flow.</p></article><article><span>3</span><h3>Resolve</h3><p>Track evidence, approvals and work to completion.</p></article><article><span>4</span><h3>Improve</h3><p>Use operational data to identify bottlenecks and trends.</p></article></div>
      </div>
    </section>

    <section class="v6-cta-wrap">
      <div class="v6-cta-band mufk-cta-band">
        <p class="v6-kicker v6-light-kicker">Next step</p>
        <div>
          <h2>Ready to improve coordination across your claims network?</h2>
          <p>Show us how claims and service-provider work move today. We will demonstrate a more connected operating model.</p>
        </div>
        <div class="mufk-cta-actions">
          <a class="mufk-cta-product" href="https://mufk85.co.za/" target="_blank" rel="noopener noreferrer">
            <img src="/assets/img/Mutk-Integrated logo.png" alt="" aria-hidden="true" />
            <span>Explore the platform <span aria-hidden="true">↗</span></span>
          </a>
          <a class="v6-default-btn v6-white-btn" routerLink="/contact">Discuss your claims workflow</a>
        </div>
      </div>
    </section>
  </main>
</div>